module.exports = __webpack_public_path__ + "static/media/technical_classroom.b392180b.jpg";